// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContestPayoutInfo{box-sizing:border-box}.ContestPayoutInfo .heading{margin-bottom:2px;border-bottom:1px solid #4c4c4c;width:640px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
